/*
 * @Description: 教务数据管理
 */
import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/pcHome.vue'
const dataAnalysisRouter: Array<RouteRecordRaw> = [
    {
        path: '/dataAnalysis',
        component: Layout,
        redirect: '/dataAnalysis/panelData',
        children: [
          {
            path: 'dataManage',
            component: () => import(/* webpackChunkName: "DataManage" */ '@/views/dataAnalysis/dataManage/index.vue'),
            name: 'DataManage',
            meta: { title: '事件管理' }
          },
          {
            path: 'panelManage',
            component: () => import(/* webpackChunkName: "PanelManage" */ '@/views/dataAnalysis/panelManage/index.vue'),
            name: 'PanelManage',
            redirect:'/dataAnalysis/panelManage/manageList',
            meta: { title: '看板管理' },
            children: [
              {
                path: 'manageList',
                component: () => import(/* webpackChunkName: "ManageList" */ '@/views/dataAnalysis/panelManage/manage.vue'),
                name: 'ManageList',
                meta: { title: '看板列表' }
              },
              {
                path: 'manageDetails',
                component: () => import(/* webpackChunkName: "ManageDetails" */ '@/views/dataAnalysis/panelManage/details.vue'),
                name: 'ManageDetails',
                meta: { title: '看板详情' }
              },
            ]
          },
          {
            path: 'panelData',
            component: () => import(/* webpackChunkName: "PanelData" */ '@/views/dataAnalysis/panelData/index.vue'),
            name: 'PanelData',
            meta: { title: '数据看板' }
          },
          {
            path: 'panelDetail',
            component: () => import(/* webpackChunkName: "PanelDetail" */ '@/views/dataAnalysis/panelDetail/index.vue'),
            name: 'PanelDetail',
            meta: { title: '指标详情' }
          },
          {
            path: 'panelImportDetail',
            component: () => import(/* webpackChunkName: "PanelDetail" */ '@/views/dataAnalysis/panelDetail/imporDetailt.vue'),
            name: 'panelImportDetail',
            meta: { title: '指标详情' }
          },
          {
            path: 'indicatorManage',
            component: () => import(/* webpackChunkName: "IndicatorManage" */ '@/views/dataAnalysis/indicatorManage/index.vue'),
            name: 'IndicatorManage',
            meta: { title: '指标管理' }
          },
         
        ]
      }
]

export default dataAnalysisRouter
